module.exports = __webpack_public_path__ + "img/crown-3.7c2c159.png";